import $ from 'jquery';
import prestashop from 'prestashop';
import { handleClassicAddToCartSuccess } from './classic-block-cart';
import 'bootstrap-touchspin';

prestashop.cart = prestashop.cart || {};

prestashop.cart.active_inputs = null;

const spinnerSelector = 'input[name="product-quantity-spin"]';
let hasError = false;
let isUpdateOperation = false;
let errorMsg = '';

/**
 * Attach Bootstrap TouchSpin event handlers
 */
function createSpin() {
    const $quantityInput = $($(spinnerSelector));

    $quantityInput.TouchSpin({
        buttondown_class: 'btn-touchspin js-touchspin js-increase-product-quantity',
        buttonup_class: 'btn-touchspin js-touchspin js-decrease-product-quantity',
        max: 1000000,
        min: 1,
        verticalbuttons: true,
        verticalup: '<i class="fas fa-chevron-up h-2 w-2"></i>',
        verticaldown: '<i class="fas fa-chevron-down h-2 w-2"></i>',
    });

    var quantity = $quantityInput.val();
    $quantityInput.on('keyup change', function (event) {
        const newQuantity = $(this).val();
        if (newQuantity !== quantity) {
            quantity = newQuantity;
            let $productRefresh = $('.product-refresh');
            $(event.currentTarget).trigger('touchspin.stopspin');
            $productRefresh.trigger('click', { eventType: 'updatedProductQuantity' });
        }
        event.preventDefault();

        return false;
    });

    CheckUpdateQuantityOperations.switchErrorStat();
}

$(document).ready(() => {
    const productLineInCartSelector = '.js-cart-line-product-quantity';
    const promises = [];

    prestashop.on('updateCart', () => {
        const $quickview = $('.quickview');
        if ($quickview.length && typeof $.fn.modal === 'function') {
            $quickview.modal('hide');
        }
    });

    prestashop.on('updatedCart', () => {
        createSpin();
    });

    createSpin();

    const $body = $('body');

    $body.on('click', '[data-button-action="add-to-cart"]', (event) => {
        event.preventDefault();

        const $button = $(event.currentTarget);
        let $form = $button.closest('form');

        if (!$form.length && event.currentTarget.form) {
            $form = $(event.currentTarget.form);
        }

        if (!$form.length) {
            $form = $('#add-to-cart-or-refresh');
        }

        if (!$form.length) {
            return;
        }

        const actionURL = $form.attr('action');
        const addToCartButton = $button;

        addToCartButton.prop('disabled', true);

        const isQuantityInputValid = ($input) => {
            let validInput = true;

            $input.each((index, input) => {
                const $currentInput = $(input);
                const minimalValue = parseInt($currentInput.attr('min'), 10);

                if (minimalValue && $currentInput.val() < minimalValue) {
                    onInvalidQuantity($currentInput);
                    validInput = false;
                }
            });

            return validInput;
        };

        let onInvalidQuantity = ($input) => {
            $input
                .parents(prestashop.selectors.product.addToCart)
                .first()
                .find(prestashop.selectors.product.minimalQuantity)
                .addClass('error');
            $input
                .parent()
                .find('label')
                .addClass('error');
        };

        const $quantityInput = $form.find('input[min]');

        if (!isQuantityInputValid($quantityInput)) {
            onInvalidQuantity($quantityInput);
            addToCartButton.prop('disabled', false);

            return;
        }

        const isClassicProductPage = document.querySelector('.js-classic-product-page') !== null;

        const buildCartRequestData = (customizationId) => {
            const params = new URLSearchParams($form.serialize());

            params.set('add', '1');
            params.set('action', 'update');
            params.set('ajax', '1');

            if (customizationId && params.has('id_customization')) {
                params.set('id_customization', String(customizationId));
            }

            return params;
        };

        const getCartErrorMessage = (resp) => {
            if (!resp) {
                return '';
            }

            if (Array.isArray(resp.errors)) {
                return resp.errors.join('<br/>');
            }

            return resp.errors || '';
        };

        const postProductToCart = (customizationId) => {
            $.ajax({
                url: actionURL,
                method: 'POST',
                data: buildCartRequestData(customizationId).toString(),
                dataType: 'json',
            })
            .done((resp) => {
                if (resp.hasError) {
                    prestashop.emit('showErrorNextToAddtoCartButton', {
                        errorMessage: getCartErrorMessage(resp),
                    });

                    return;
                }

                if (isClassicProductPage) {
                    handleClassicAddToCartSuccess(resp);
                }

                prestashop.emit('updateCart', {
                    reason: {
                        idProduct: resp.id_product,
                        idProductAttribute: resp.id_product_attribute,
                        idCustomization: resp.id_customization,
                        linkAction: isClassicProductPage ? 'classic-add-to-cart' : 'add-to-cart',
                        cart: resp.cart,
                    },
                    resp,
                });
            })
            .fail(() => {
                prestashop.emit('showErrorNextToAddtoCartButton', {
                    errorMessage: 'Impossible d\'ajouter le produit au panier. Veuillez réessayer.',
                });
                prestashop.emit('handleError', {
                    eventType: 'addProductToCart',
                });
            })
            .always(() => {
                setTimeout(() => {
                    addToCartButton.prop('disabled', false);
                }, 1000);
            });
        };

        if (isClassicProductPage) {
            postProductToCart();

            return;
        }

        window.addEventListener('fetch-finished', (e) => {
            const customizationId = e.detail && e.detail.id_customization != null
                ? e.detail.id_customization
                : undefined;
            const params = buildCartRequestData(customizationId);

            $.ajax({
                url: actionURL,
                method: 'POST',
                data: params.toString(),
                dataType: 'json',
            })
            .done((resp) => {
                if (resp.hasError) {
                    prestashop.emit('showErrorNextToAddtoCartButton', {
                        errorMessage: getCartErrorMessage(resp),
                    });

                    return;
                }

                prestashop.emit('updateCart', {
                    reason: {
                        idProduct: resp.id_product,
                        idProductAttribute: resp.id_product_attribute,
                        idCustomization: resp.id_customization,
                        linkAction: 'add-to-cart',
                        cart: resp.cart,
                    },
                    resp,
                });
            })
            .fail((resp) => {
                prestashop.emit('handleError', {
                    eventType: 'addProductToCart',
                    resp,
                });
            })
            .always(() => {
                setTimeout(() => {
                    addToCartButton.prop('disabled', false);
                }, 1000);
            });
        }, { once: true });
    });

    function isTouchSpin(namespace) {
        return namespace === 'on.startupspin' || namespace === 'on.startdownspin';
    }

    function shouldIncreaseProductQuantity(namespace) {
        return namespace === 'on.startupspin';
    }

    function findCartLineProductQuantityInput($target) {
        const $input = $target.parents('.bootstrap-touchspin').find(productLineInCartSelector);

        if ($input.is(':focus')) {
            return null;
        }

        return $input;
    }

    function camelize(subject) {
        const actionTypeParts = subject.split('-');
        let i;
        let part;
        let camelizedSubject = '';

        for (i = 0; i < actionTypeParts.length; i += 1) {
            part = actionTypeParts[i];

            if (i !== 0) {
                part = part.substring(0, 1).toUpperCase() + part.substring(1);
            }

            camelizedSubject += part;
        }

        return camelizedSubject;
    }

    function parseCartAction($target, namespace) {
        if (!isTouchSpin(namespace)) {
            return {
                url: $target.attr('href'),
                type: camelize($target.data('link-action')),
            };
        }

        const $input = findCartLineProductQuantityInput($target);

        if (!$input) {
            return false;
        }

        let cartAction = {};

        if (shouldIncreaseProductQuantity(namespace)) {
            cartAction = {
                url: $input.data('up-url'),
                type: 'increaseProductQuantity',
            };
        } else {
            cartAction = {
                url: $input.data('down-url'),
                type: 'decreaseProductQuantity',
            };
        }

        return cartAction;
    }

    const abortPreviousRequests = () => {
        let promise;
        while (promises.length > 0) {
            promise = promises.pop();
            promise.abort();
        }
    };

    const getTouchSpinInput = ($button) => $($button.parents('.bootstrap-touchspin').find('input'));

    const handleCartAction = (event) => {
        event.preventDefault();

        const $target = $(event.currentTarget);
        const { dataset } = event.currentTarget;
        const cartAction = parseCartAction($target, event.namespace);
        const requestData = {
            ajax: '1',
            action: 'update',
        };

        if (!cartAction) {
            return;
        }

        abortPreviousRequests();

        if($($target[0]).hasClass('js-cart-item-remove')) {
            const productWrapper = $($target[0]).closest('.js-cart-linked-wrapper');
            
            if(productWrapper.length) {
                const linkedRemove = productWrapper.find('.js-cart-linked-item-remove');
                const action = parseCartAction(linkedRemove, event.namespace);

                $.ajax({
                    url: action.url,
                    method: 'POST',
                    data: requestData,
                    dataType: 'json',
                    beforeSend(jqXHR) {
                        promises.push(jqXHR);
                    },
                })
                .then((resp) => {
                    CheckUpdateQuantityOperations.checkUpdateOpertation(resp);
                    const $quantityInput = getTouchSpinInput($target);
                    $quantityInput.val(resp.quantity);
                })
                .fail((resp) => {
                    prestashop.emit('handleError', {
                        eventType: 'updateProductInCart',
                        resp,
                        cartAction: action.type,
                    });
                });
            }
        }

        $.ajax({
            url: cartAction.url,
            method: 'POST',
            data: requestData,
            dataType: 'json',
            beforeSend(jqXHR) {
                promises.push(jqXHR);
            },
        })
            .then((resp) => {
                CheckUpdateQuantityOperations.checkUpdateOpertation(resp);
                const $quantityInput = getTouchSpinInput($target);
                $quantityInput.val(resp.quantity);

                // Refresh cart preview
                prestashop.emit('updateCart', {
                    reason: dataset,
                    resp,
                });
            })
            .fail((resp) => {
                prestashop.emit('handleError', {
                    eventType: 'updateProductInCart',
                    resp,
                    cartAction: cartAction.type,
                });
            });
    };

    $body.on('click', '[data-link-action="delete-from-cart"], [data-link-action="remove-voucher"]', handleCartAction);

    $body.on('touchspin.on.startdownspin', spinnerSelector, handleCartAction);
    $body.on('touchspin.on.startupspin', spinnerSelector, handleCartAction);

    function sendUpdateQuantityInCartRequest(updateQuantityInCartUrl, requestData, $target) {
        abortPreviousRequests();

        return $.ajax({
            url: updateQuantityInCartUrl,
            method: 'POST',
            data: requestData,
            dataType: 'json',
            beforeSend(jqXHR) {
                promises.push(jqXHR);
            },
        })
            .then((resp) => {
                CheckUpdateQuantityOperations.checkUpdateOpertation(resp);
                $target.val(resp.quantity);

                let dataset;

                if ($target && $target.dataset) {
                    // eslint-disable-next-line
                    dataset = $target.dataset;
                } else {
                    dataset = resp;
                }

                // Refresh cart preview
                prestashop.emit('updateCart', {
                    reason: dataset,
                    resp,
                });
            })
            .fail((resp) => {
                prestashop.emit('handleError', {
                    eventType: 'updateProductQuantityInCart',
                    resp,
                });
            });
    }

    function getRequestData(quantity) {
        return {
            ajax: '1',
            qty: Math.abs(quantity),
            action: 'update',
            op: getQuantityChangeType(quantity),
        };
    }

    function getQuantityChangeType($quantity) {
        return $quantity > 0 ? 'up' : 'down';
    }

    function updateProductQuantityInCart(event) {
        const $target = $(event.currentTarget);
        const updateQuantityInCartUrl = $target.data('update-url');
        const baseValue = $target.attr('value');

        // There should be a valid product quantity in cart
        const targetValue = $target.val();
        /* eslint-disable */
        if (targetValue != parseInt(targetValue, 10) || targetValue < 0 || isNaN(targetValue)) {
            $target.val(baseValue);
            return;
        }
        /* eslint-enable */
        // There should be a new product quantity in cart
        const qty = targetValue - baseValue;

        if (qty === 0) {
            return;
        }

        $target.attr('value', targetValue);
        sendUpdateQuantityInCartRequest(updateQuantityInCartUrl, getRequestData(qty), $target);
    }

    $body.on('focusout keyup', productLineInCartSelector, (event) => {
        if (event.type === 'keyup') {
            if (event.keyCode === 13) {
                updateProductQuantityInCart(event);
            }
            return false;
        }

        updateProductQuantityInCart(event);

        return false;
    });

    const $timeoutEffect = 400;

    $body.on('hidden.bs.collapse', '#promo-code', () => {
        $('.display-promo').show($timeoutEffect);
    });

    $body.on('click', '.promo-code-button', (event) => {
        event.preventDefault();

        $('#promo-code').collapse('toggle');
    });

    $body.on('click', '.display-promo', (event) => {
        $(event.currentTarget).hide($timeoutEffect);
    });

    $body.on('click', '.js-discount .code', (event) => {
        event.stopPropagation();

        const $code = $(event.currentTarget);
        const $discountInput = $('[name=discount_name]');

        $discountInput.val($code.text());
        // Show promo code field
        $('#promo-code').collapse('show');
        $('.display-promo').hide($timeoutEffect);

        return false;
    });
});

const CheckUpdateQuantityOperations = {
    switchErrorStat: () => {
        /**
         * if errorMsg is not empty or if notifications are shown, we have error to display
         * if hasError is true, quantity was not updated : we don't disable checkout button
         */
        const $checkoutBtn = $('.checkout a');

        if ($('#notifications article.alert-danger').length || (errorMsg !== '' && !hasError)) {
            $checkoutBtn.addClass('disabled');
        }

        if (errorMsg !== '') {
            // eslint-disable-next-line
            const strError = ` <article class="alert alert-danger" role="alert" data-alert="danger"><ul><li>${errorMsg}</li></ul></article>`;
            $('#notifications .container').html(strError);
            errorMsg = '';
            isUpdateOperation = false;
            if (hasError) {
                // if hasError is true, quantity was not updated : allow checkout
                $checkoutBtn.removeClass('disabled');
            }
        } else if (!hasError && isUpdateOperation) {
            hasError = false;
            isUpdateOperation = false;
            $('#notifications .container').html('');
            $checkoutBtn.removeClass('disabled');
        }
    },
    checkUpdateOpertation: (resp) => {
        /**
         * resp.hasError can be not defined but resp.errors not empty: quantity is updated but order cannot be placed
         * when resp.hasError=true, quantity is not updated
         */
        // eslint-disable-next-line
        hasError = resp.hasOwnProperty('hasError');
        const errors = resp.errors || '';

        // 1.7.2.x returns errors as string, 1.7.3.x returns array
        if (errors instanceof Array) {
            errorMsg = errors.join(' ');
        } else {
            errorMsg = errors;
        }

        isUpdateOperation = true;
    },
};